import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30ee83c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-fanhui" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import {computed, ref} from 'vue';
import {ImagePreview} from 'vant';
import useUa from '@/hooks/useUa';
import {useDeviceInfo} from '@/hooks/useDeviceInfo';
import {usePopReturn} from '@/hooks/usePopReturn';
import {saveImageToAlbum} from '@/bridge';


const __default__ = {
  name: 'ImagePreview'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isShowImage: { type: Boolean },
    previewImages: null,
    cancelShowImage: null,
    startPosition: null
  },
  setup(__props: any) {

const props = __props as {
  isShowImage: boolean;
  previewImages: string[];
  cancelShowImage:() => void;
  startPosition: number;
}

const VanImagePreview = ImagePreview.Component;



const {isApp} = useUa();
const {statusBarHeight} = useDeviceInfo();

const showImage = computed({
  get() {
    return props.isShowImage;
  },
  set(val:boolean) {
    props.cancelShowImage();
  },
});

// 点击返回按钮
const handleBackIconClick = () => {
  props.cancelShowImage();
};

// 记录当前图片 index
const curPosition = ref<number>(props.startPosition);
const handleIndexChange = (index: number) => {
  curPosition.value = index;
};

// 保存图片
const handleSaveImage = () => {
  // 调用端能力
  saveImageToAlbum(props.previewImages[curPosition.value]);
};

const {handleClose, handleOpen} = usePopReturn(showImage, props.cancelShowImage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VanImagePreview), {
    show: _unref(showImage),
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showImage) ? (showImage).value = $event : null)),
    "show-index": true,
    "start-position": __props.startPosition,
    "close-icon-position": "top-left",
    images: __props.previewImages,
    "overlay-style": {backgroundColor: 'rgba(#000, 0.6)'},
    loop: false,
    onChange: handleIndexChange,
    onClose: _unref(handleClose),
    onOpen: _unref(handleOpen)
  }, {
    cover: _withCtx(() => [
      _createElementVNode("div", {
        class: "preview-cover",
        style: _normalizeStyle({marginTop: `calc(${_unref(statusBarHeight)} + 6px)`})
      }, [
        (_openBlock(), _createElementBlock("svg", {
          class: "icon back-icon",
          "aria-hidden": "true",
          onClick: handleBackIconClick
        }, _hoisted_2)),
        (_unref(isApp))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "save-btn",
              onClick: handleSaveImage
            }, "保存图片"))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 1
  }, 8, ["show", "start-position", "images", "overlay-style", "onClose", "onOpen"]))
}
}

})